export const GET_ALL_TESTS_REQUEST = 'GET_ALL_TESTS_REQUEST'
export const GET_ALL_TESTS_SUCCESS = 'GET_ALL_TESTS_SUCCESS'
export const GET_ALL_TESTS_FAIL = 'GET_ALL_TESTS_FAIL'
 